// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__iKqGA1VN","countSelected":"ManageSelection_countSelected__fhd9ihlD"};